import { createAssignmentUnitEpicReducer } from "./epicsV2.js";
const getCreateAssignmentUnitEpicReducer = () => createAssignmentUnitEpicReducer;
const rootEpic = createAssignmentUnitEpicReducer.epic;
export {
  rootEpic as default,
  getCreateAssignmentUnitEpicReducer,
  rootEpic
};
//# sourceMappingURL=epics.js.map
